import { Icon } from "@/design-system";

export default function SearchInput({
  value = "",
  onChange,
  onClear,
  placeholder = "",
  "aria-label": ariaLabel,
  className = "",
  ...inputProps
}) {
  const clear = () => {
    onChange && onChange("");
    onClear && onClear();
  };

  return (
    <div className={`relative ${className}`}>
      <Icon
        name="search"
        size={15}
        weight={400}
        className="pointer-events-none absolute left-[9px] top-1/2 -translate-y-1/2 text-ink-3"
      />
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange && onChange(event.target.value)}
        aria-label={ariaLabel || placeholder || "Search filters"}
        className="h-[30px] pl-[28px] pr-[26px] text-xs w-full [box-sizing:border-box] rounded-pill border-[1.5px] border-line bg-card font-sans text-ink outline-none placeholder:text-ink-3 [transition:border-color_var(--duration-fast),box-shadow_var(--duration-base)_var(--ease-out)] hover:border-line-strong focus:border-line-strong focus:shadow-md [&::-webkit-search-cancel-button]:appearance-none"
        {...inputProps}
      />
      {value && (
        <button
          type="button"
          onClick={clear}
          aria-label="Clear search"
          className="absolute right-[5px] h-[20px] w-[20px] top-1/2 inline-flex -translate-y-1/2 items-center justify-center rounded-full border-0 bg-transparent text-ink-3 [transition:background_var(--duration-fast),color_var(--duration-fast)] hover:bg-neutral-100 hover:text-ink focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
        >
          <Icon name="close" size={15} weight={400} />
        </button>
      )}
    </div>
  );
}
